import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import cookies from "js-cookie";

// Components
import HomePage from "./HomePage";
import AdminLogin from "./components/Admin/AdminLogin";
import Stats from "./components/Admin/Stats";
import Admin from "./components/Admin/Admin";
import { Order } from "./components/Admin/Order";
import { PastOrders } from "./components/Admin/PastOrders";
import { Accounts } from "./components/Admin/Accounts";
import VideoBox from "./components/Main/VideoBox";

const instructions_en =
  "https://axwwwwm69s0m.objectstorage.us-phoenix-1.oci.customer-oci.com/p/P06W6SBcIan9n84DYbMPfFsStsT3crP_2dOjHR_G31qIvoTtsgclFPwU4CIwDMRT/n/axwwwwm69s0m/b/jacobs-bucket/o/20250707_120043_250959231764733.mp4";
const whats_next_es =
  "https://axwwwwm69s0m.objectstorage.us-phoenix-1.oci.customer-oci.com/p/F8z72DNAp4DAGIiBaS_lAq1J3iGCpxh3-ZBS2n0WxTb_MwdrDMO7P6dZDhKbwyjV/n/axwwwwm69s0m/b/jacobs-bucket/o/20250707_112936_250294140706185.mp4";
const whats_next_en =
  "https://axwwwwm69s0m.objectstorage.us-phoenix-1.oci.customer-oci.com/p/1Mj7T_yKX9_PNuH2KA_XDlpOB1wNXUW_lihDpXqHqpnVOMF7Sx5XalQap1U2OLCZ/n/axwwwwm69s0m/b/jacobs-bucket/o/20250707_125026_251692363401850.mp4";
const instructions_es =
  "https://axwwwwm69s0m.objectstorage.us-phoenix-1.oci.customer-oci.com/p/J9oOD9B2oQ1kZwNulpiQKwihLNbNIObfWGJWUIerE7_NvT5SO_BzMFflKAKqpMB0/n/axwwwwm69s0m/b/jacobs-bucket/o/20250707_112701_250138987866505.mp4";

interface Props {}

const currentLanguageCode = cookies.get("i18next") || "en";

function App(props: Props) {
  console.log(currentLanguageCode);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/instructions"
          element={
            <VideoBox
              video_source={
                currentLanguageCode === "es" ? instructions_es : instructions_en
              }
            />
          }
        />
        <Route
          path="whatsnext"
          element={
            <VideoBox
              video_source={
                currentLanguageCode === "es" ? whats_next_es : whats_next_en
              }
            />
          }
        />
        <Route path="/mobileadmin" element={<AdminLogin />}>
          <Route index element={<Admin />} />
          <Route path="stats" element={<Stats />} />
          <Route path=":id" element={<Order />} />
          <Route path="pastorders" element={<PastOrders />} />
          <Route path="accounts" element={<Accounts />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
